import Vue from "vue";
import Router from "vue-router";
import Home from "./views/Home.vue";
import ReceiptSearch from "./views/ReceiptSearch.vue";
import ReceiptView from "./views/ReceiptView.vue";

Vue.use(Router);

export default new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      name: "home",
      component: Home
    },
    {
      path: "/:receiptSlug",
      name: "receiptSearch",
      component: ReceiptSearch,
      props: true
    },
    {
      path: "/receipts/:receiptId",
      name: "receiptView",
      component: ReceiptView,
      props: true
    },
    {
      path: "/about",
      name: "about",
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () =>
        import(/* webpackChunkName: "about" */ "./views/About.vue")
    },
    {
      path: "*",
      component: ReceiptSearch,
      // eslint-disable-next-line no-unused-vars
      beforeEnter: (to, from, next) => {
        if (to.path && to.path.startsWith("/")) {
          // remove leading slash
          const path = to.path.substr(1); // strip leading slash
          return next(path);
        }
        return next();
      }
    }
  ]
});
